import React from 'react';
import UnknownErrorPage from '@commoncomponents/frontend-components/dist/components/ErrorPages/UnknownErrorPage';
import styled from 'styled-components';
const Wrapper = styled.div `
  position: absolute;
  z-index: 1000;
  width: 100%;
  height: 100%;
`;
const UnknownError = ({ translations, buttonProps, history, }) => {
    const reloadPage = () => history.go(0);
    return (React.createElement(React.Fragment, null,
        React.createElement(Wrapper, null,
            React.createElement(UnknownErrorPage, { translations: translations, buttonProps: Object.assign(Object.assign({}, buttonProps), { onClick: reloadPage }) }))));
};
export default UnknownError;
